// extracted by mini-css-extract-plugin
export default {"root":"button-icon_root__pteg9"};